// Generated by CoffeeScript 1.12.7
var ARGUMENT_NAMES, STRIP_COMMENTS;

STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/g;

ARGUMENT_NAMES = /([^\s,]+)/g;

module.exports = function(func) {
  var fnStr, result;
  if (!(func instanceof Function)) {
    throw new TypeError('Argument must be a function');
  }
  fnStr = func.toString().replace(STRIP_COMMENTS, "");
  result = fnStr.slice(fnStr.indexOf("(") + 1, fnStr.indexOf(")")).match(ARGUMENT_NAMES);
  if (result === null) {
    result = [];
  }
  return result;
};
